const tableauCheatSheet = {
  id: "tableau",
  title: "Tableau Cheatsheet",
  description: "Complete guide to data visualization with Tableau",
  language: "tableau",
  category: "Data Visualization",
  level: "All Levels",
  sections: [
    {
      title: "Getting Started",
      items: [
        {
          title: "Data Connection",
          content: "Connect to various data sources",
          code: `# Live Connection
File → Connect to Data → Select Source
Server: localhost, Port: 3306

# Extract Connection
Data → Extract → Configure...
Incremental Refresh: Yes
Refresh Schedule: Daily`,
          note: "Use extracts for better performance with large datasets",
        },
        {
          title: "Workspace Elements",
          content: "Understanding the Tableau interface",
          code: `# Main Elements
Sheets: Individual visualizations
Dashboards: Collection of sheets
Stories: Sequence of dashboards
Shelves: Rows, Columns, Filters
Cards: Color, Size, Labels
Marks: Visual elements`,
          note: "Master these elements for effective visualization",
        },
      ],
    },
    {
      title: "Basic Visualizations",
      items: [
        {
          title: "Creating Charts",
          content: "Essential chart types and their creation",
          code: `# Bar Chart
Dimension → Columns
Measure → Rows
Mark Type: Bar

# Line Chart
Date → Columns
Measure → Rows
Mark Type: Line

# Scatter Plot
Measure 1 → Columns
Measure 2 → Rows
Mark Type: Circle`,
          note: "Choose chart types based on your data story",
        },
        {
          title: "Formatting",
          content: "Customize visualization appearance",
          code: `# Color Formatting
Right-click → Format...
Edit Colors → Select Palette
Opacity → Adjust transparency

# Label Formatting
Marks Card → Labels
Edit Label → Custom text
Font, Size, Color options`,
          note: "Consistent formatting enhances readability",
        },
      ],
    },
    {
      title: "Calculations",
      items: [
        {
          title: "Calculated Fields",
          content: "Create custom calculations",
          code: `# Basic Calculations
SUM([Sales]) / SUM([Quantity])
DATEDIFF('day', [Order Date], [Ship Date])

# Level of Detail (LOD)
{FIXED [Category] : SUM([Sales])}
{INCLUDE [Region] : AVG([Profit])}
{EXCLUDE [Date] : SUM([Quantity])}`,
          note: "LOD expressions override context filters",
        },
        {
          title: "Table Calculations",
          content: "Row and table-level computations",
          code: `# Running Total
RUNNING_SUM(SUM([Sales]))

# Percent of Total
SUM([Sales]) / TOTAL(SUM([Sales]))

# Year over Year Growth
(SUM([Sales]) - LOOKUP(SUM([Sales]), -1))
/ LOOKUP(SUM([Sales]), -1)`,
          note: "Table calcs compute within visualization context",
        },
      ],
    },
    {
      title: "Advanced Features",
      items: [
        {
          title: "Parameters",
          content: "Create dynamic controls",
          code: `# Create Parameter
Right-click → Create Parameter
Type: String/Number/Date
List of values or Range

# Using Parameters
Create Calculated Field:
IF [Parameter] = 'Option1' THEN [Field1]
ELSE [Field2] END`,
          note: "Parameters enable interactive analysis",
        },
        {
          title: "Sets and Groups",
          content: "Organize and segment data",
          code: `# Create Set
Right-click dimension → Create Set
Condition: [Sales] > 1000
Top N: Top 10 by [Profit]

# Create Group
Right-click dimension → Create Group
Select members → Group
Edit alias names`,
          note: "Use sets for dynamic member selection",
        },
      ],
    },
    {
      title: "Dashboard Design",
      items: [
        {
          title: "Layout",
          content: "Organize dashboard elements",
          code: `# Container Types
Horizontal: Side-by-side layout
Vertical: Stacked layout
Tiled: Fixed grid layout
Floating: Free positioning

# Device Layouts
Dashboard → Device Layouts
Create layout: Desktop, Tablet, Phone
Set minimum dimensions`,
          note: "Use containers for responsive design",
        },
        {
          title: "Interactivity",
          content: "Add dashboard actions",
          code: `# Filter Actions
Dashboard → Actions → Add Action
Filter: Select source sheets
Target: Select target sheets
Clearing: Select behavior

# Highlight Actions
Dashboard → Actions → Add Action
Highlight: Select fields
Target: Select sheets
Menu: Show/hide command buttons`,
          note: "Actions create interactive dashboards",
        },
      ],
    },
  ],
};

export default tableauCheatSheet;
